.do{aspect-ratio:1/1;}